"use client";

import type {Cache} from "swr";
import {SWRConfig} from "swr";
import {useRef} from "react";

const SWR_CACHE_KEY = "h5-swr-cache";

const createPersistCache = () => {
    const map = new Map<string, unknown>();

    const saveCache = () => {
        if (typeof window === "undefined") {
            return;
        }

        try {
            localStorage.setItem(
                SWR_CACHE_KEY,
                JSON.stringify(
                    Object.fromEntries(map),
                ),
            );
        } catch (error) {
            console.warn(
                "SWR cache persist failed",
                error,
            );
        }
    };

    if (typeof window !== "undefined") {
        try {
            const cache =
                localStorage.getItem(SWR_CACHE_KEY);

            if (cache) {
                const data = JSON.parse(cache);
                Object.entries(data).forEach(
                    ([key, value]) => {

                        if (
                            value &&
                            typeof value === "object" &&
                            "error" in value &&
                            value.error
                        ) {
                            return;
                        }

                        map.set(key, value);
                    },
                );

                saveCache();
            }

        } catch (error) {
            console.warn(
                "SWR cache restore failed",
                error,
            );
        }
    }


    return {
        get(key: string) {
            return map.get(key);
        },


        set(
            key: string,
            value: unknown,
        ) {
            map.set(
                key,
                value,
            );
            queueMicrotask(
                saveCache,
            );
        },

        delete(key: string) {
            map.delete(key);
            saveCache();
        },

        keys() {
            return map.keys();
        },

    };
};


export default function SWRProvider({
                                        children,
                                    }: {
    children: React.ReactNode;
}) {

    const cacheRef = useRef<Cache | null>(null);


    if (!cacheRef.current) {
        cacheRef.current = createPersistCache() as Cache;
    }


    return (
        <SWRConfig
            value={{
                provider: () => cacheRef.current!,
                revalidateOnFocus: false,
                revalidateOnReconnect: true,
                dedupingInterval: 5000,
            }}
        >
            {children}
        </SWRConfig>
    );
}
